import Axios from '../plugins/axios'

export const fetchLanguages = function () {
    return Axios.get('languages')
}

export const createLanguage = function (language) {
    return Axios.post('languages', language);
}

export const fetchGroups = function () {
    return Axios.get('languages/groups');
}

export const fetchTranslationsByGroup = function (group) {
    return Axios.get(`languages/strings/group/${group}`);
}

export const fetchTranslationsIdentifiersByGroup = function (group) {
    return Axios.get(`languages/identifiers/group/${group}`);
}